import { produce } from 'immer';

export const ACTIONS = {
  DB_INFOS_CHANGED: 'DB_INFOS_CHANGED',
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.DB_INFOS_CHANGED:
      _setDbInfos({ draft, payload: action.payload });
      break;

    default:
      throw new Error(`Unhandled action type ${action.type}`);
  }
});

export default reducer;

function _setDbInfos({ draft, payload }) {
  const syncing = (payload || []).find((item) => item.name === 'syncing') || {};
  draft.infos.syncing = syncing.value;
}
